
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2186',
  depVersions: {
  "customer-portal-app": "static-1.2186",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.464",
  "data-fetching-client": "static-1.9638",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.428",
  "growth-payments-core": "static-1.25269",
  "head-dlb": "static-1.4938",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5559",
  "hs-test-utils": "static-1.7981",
  "hub-http": "static-1.6187",
  "hub-http-shared-msw-handlers": "static-1.9874",
  "hubspot-dlb": "static-2.1832",
  "hubspot-prosemirror": "static-1.18141",
  "hubspot-url-utils": "static-1.4049",
  "HubStyleTokens": "static-2.11427",
  "I18n": "static-7.1615",
  "immutable": "static-2.77",
  "jasmine-runner": "static-1.6433",
  "payment-link-components": "static-1.23433",
  "prosemirror": "static-1.13",
  "quartz": "static-1.6973",
  "quartz-core": "static-1.6192",
  "react": "static-7.185",
  "react-colorpicker": "static-2.10177",
  "react-dlb": "static-1.78",
  "react-utils": "static-2.5315",
  "rich-text-lib": "static-1.19768",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.17935",
  "ui-components-test-utils": "static-1.5565",
  "UIComponents": "static-3.8374",
  "foundations-assets": "static-1.4823",
  "foundations-components": "static-1.7857",
  "foundations-theming": "static-1.4383",
  "foundations-theming-specialty": "static-1.2099",
  "framer-motion": "static-1.71",
  "metrics-js": "static-1.9542",
  "PortalIdParser": "static-2.388",
  "portals-platform-lib": "static-1.833",
  "quartz-config": "static-1.751",
  "quartz-routing": "static-1.403",
  "quick-fetch": "static-1.3887",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16634",
  "rpc-client-utils": "static-1.4617",
  "sanitize-text": "static-1.8109",
  "styled-components": "static-2.88",
  "tanstack-table": "static-1.54",
  "ui-addon-draggable": "static-3.4735",
  "ui-addon-react-router-dom": "static-1.9511",
  "usage-tracker": "static-1.7303",
  "usage-tracker-anonymous": "static-1.5720",
  "usage-tracker-core": "static-1.7153",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5489",
  "raven": "static-3.5829",
  "raven-hubspot": "static-1.6136",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.70",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3374",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3250",
  "quartz-webpack": "static-1.3197",
  "bend-plugin-quartz-routing": "static-1.51",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.81",
  "customer-data-objects": "static-1.7629",
  "frontend-preferences-client": "static-1.7895",
  "laboratory-lib": "static-3.7125",
  "onboarding-scopes": "static-1.6428",
  "ui-addon-opt": "static-4.8337",
  "HeadJS": "static-2.742",
  "hs-test-utils-bend-plugin": "static-1.3092",
  "msw": "static-1.39",
  "testing-library": "static-1.151",
  "hs-locale-management": "static-1.55",
  "ts-schema": "static-1.4049",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7696",
  "cssUtils": "static-1.782",
  "customer-data-ui-utilities": "static-1.9793",
  "HubStyle": "static-2.11735",
  "knowledge-content-types": "static-1.8483",
  "PatternValidationJS": "static-1.437",
  "quartz-i18n": "static-1.648",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.486",
  "ui-addon-emoji-picker": "static-1.9854",
  "ui-addon-i18n": "static-1.11116",
  "ui-business-units-lib": "static-1.9015",
  "ui-shepherd-react": "static-3.10118",
  "video-components-external": "static-1.11150",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.82",
  "jasmine": "static-4.4290",
  "commerce-tours-lib": "static-1.6025",
  "customer-data-properties": "static-1.51422",
  "getting-started-shared-tasks": "static-1.18401",
  "growth-onboarding-reliability": "static-1.5047",
  "onboarding-tours": "static-1.16528",
  "reference-resolvers-lite": "static-1.8060",
  "sales-checkout-service-client": "static-1.3606",
  "ui-addon-iframeable": "static-1.9024",
  "user-context": "static-1.5069",
  "dispatcher": "static-1.135",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.828",
  "hubspotter-http": "static-1.4623",
  "icons": "static-2.644",
  "mobile-manifest-mixins": "static-1.516",
  "module-federation": "static-1.22",
  "quartz-auth": "static-1.648",
  "quartz-head": "static-1.638",
  "quartz-test": "static-1.648",
  "quartz-tracking": "static-1.352",
  "ui-fonts": "static-1.689",
  "usage-tracker-container": "static-1.7293",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9395",
  "data-token-picker": "static-1.16342",
  "FileManagerLib": "static-1.39155",
  "property-translator": "static-1.5367",
  "atom": "static-1.5038",
  "merchandise-lib": "static-1.262",
  "purchase-motions-components": "static-1.5817",
  "salesImages": "static-1.524",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5340",
  "react-select-plus": "static-1.104",
  "react-virtualized": "static-2.98",
  "ui-images": "static-2.1143",
  "bend-plugin-foundations-components": "static-1.4126",
  "floating-ui": "static-1.55",
  "react-aria": "static-1.65",
  "react-create-root-preference": "static-1.13",
  "trellis-assets": "static-1.1746",
  "bend-plugin-foundations-theming": "static-1.2866",
  "foundations-theming-base": "static-1.3368",
  "stylex": "static-1.32",
  "interframe": "static-3.4727",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5717",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "web-vitals": "static-1.4",
  "bend-plugin-chirp-manifest": "static-1.27",
  "chirp-fetch": "static-1.1851",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4438",
  "react-flip-move": "static-1.69",
  "bender-build-tools": "static-1.3147",
  "inbound-db-properties-service-client": "static-1.3811",
  "superstore": "static-1.4732",
  "feedback-loader": "static-1.29229",
  "ai-components-ui-library": "static-1.8844",
  "ui-addon-video-player": "static-1.8664",
  "ui-coaching-tips": "static-1.28445",
  "sassPrefix": "static-1.155",
  "react-dnd-compat": "static-1.4586",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2464",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8135",
  "reselect": "static-2.16",
  "apollo-link-hub-http": "static-2.4614",
  "content-media-composition-data-lib": "static-1.12135",
  "content-media-compositions": "static-2.16142",
  "idb-keyval": "static-1.43",
  "immer": "static-1.33",
  "immerable": "static-1.4120",
  "magpie-lib": "static-1.5536",
  "magpie-types": "static-1.4996",
  "media-bridge-lib": "static-1.18864",
  "video-data-lib": "static-1.34808",
  "commerce-products-lib": "static-1.9407",
  "crm-message-bus": "static-1.42894",
  "growth-data-modal": "static-1.5370",
  "hubspot-apollo-client": "static-1.4842",
  "onboarding-tours-client": "static-1.4742",
  "calling-global-api": "static-1.64385",
  "calling-internal-common": "static-1.31268",
  "calling-lifecycle-internal": "static-1.65767",
  "calling-lifecycle-messages": "static-1.58061",
  "conditional-properties-service-client": "static-1.3768",
  "crm-links": "static-1.6250",
  "customer-data-objects-ui-components": "static-1.12992",
  "customer-data-properties-shared-msw-handlers": "static-1.9201",
  "customer-data-property-utils": "static-1.8049",
  "external-options-client-types": "static-1.4129",
  "file-manager-components": "static-1.23515",
  "framework-data-schema-resolvers": "static-1.6846",
  "google-libphonenumber": "static-1.37",
  "hs-resources": "static-1.115",
  "inbound-db-meta-service-client": "static-1.3561",
  "inbounddb-objects-service-types": "static-1.4194",
  "meetings-icalendar-utils-lib": "static-1.598",
  "multi-currency-client-types": "static-1.3662",
  "object-builder-ui-client": "static-1.48615",
  "pipeline-validation-client-types": "static-1.3936",
  "property-value-citations": "static-1.2036",
  "pulse": "static-1.529",
  "smart-property-lib": "static-1.6736",
  "tiered-pricing": "static-1.1126",
  "ui-addon-form-validation": "static-1.10954",
  "growth-onboarding-confetti": "static-1.3033",
  "growth-onboarding-next-action-utils": "static-1.1817",
  "navigation-components": "static-1.17912",
  "onboarding-tours-utils": "static-1.594",
  "ui-shepherd-tracker": "static-1.7499",
  "ui-universal-auth": "static-1.8930",
  "batch-promise": "static-1.1510",
  "navigation-messaging": "static-1.7239",
  "getting-started-shared-tasks-store": "static-1.17519",
  "hubspotter-http-shared-msw-handlers": "static-1.9872",
  "usage-tracker-session-replay": "static-1.4989",
  "audio-components": "static-1.5861",
  "FileManagerCore": "static-1.39014",
  "FileManagerImages": "static-1.36666",
  "video-components": "static-1.13153",
  "foundations-components-legacy": "static-1.882",
  "purchase-motions-api": "static-1.5820",
  "self-service-api": "static-1.10212",
  "signup-constants": "static-1.18780",
  "signup-ui-url-generator": "static-2.8007",
  "trials-service-types": "static-1.3870",
  "usage-tracker-public": "static-1.7114",
  "chatspot-core": "static-1.21121",
  "ContentUtils": "static-1.68254",
  "copilot-toolkit": "static-1.11037",
  "growth-onboarding-feedback-components": "static-1.6549",
  "reactive-lib": "static-1.687",
  "simple-logging-lib": "static-1.3015",
  "commerce-permissions": "static-1.732",
  "customer-data-tracking": "static-1.6852",
  "products-iframe-lib": "static-1.7832",
  "products-ui-components-shared-msw-handlers": "static-1.10256",
  "onboarding-data-sync-lib": "static-1.1901",
  "hubspot-apollo-cache": "static-1.301",
  "calling-error-reporting": "static-1.31274",
  "shared-worker-versioning": "static-1.11004",
  "calling-usage-tracker": "static-1.6509",
  "voice-sms-access-library": "static-1.839",
  "conversations-skeleton-state": "static-1.7215",
  "location-customization-utils-lib": "static-1.9144",
  "crm-pipelines-api-client-types": "static-1.4113",
  "framework-builder-read-service-client": "static-1.3980",
  "framework-data-schema-quick-fetch": "static-1.6751",
  "persist-promise": "static-1.3667",
  "bend-plugin-pulse": "static-1.32",
  "directed-graph": "static-1.901",
  "event-emitter": "static-1.914",
  "fast-json-patch": "static-1.62",
  "data-agent-kit": "static-1.135",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9957",
  "fsm": "static-1.3697",
  "policy-lib": "static-1.6739",
  "react-tinymce": "static-1.55137",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10020",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54263",
  "tinymce-plugins": "static-1.57377",
  "tinymce-themes": "static-1.56233",
  "growth-onboarding-next-action-components": "static-1.1845",
  "user-context-client": "static-1.4576",
  "nest": "static-1.193",
  "unified-auth-core-lib": "static-1.725",
  "amplitude-session-replay-browser": "static-1.59",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4497",
  "video-embed": "static-1.35642",
  "content-icons-ui": "static-1.2216",
  "social-insights-client-types": "static-1.21993",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4778",
  "integrations-lib": "static-1.16004",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.4231",
  "InboxConnectUtils": "static-4.14713",
  "calling-orchestration-schema": "static-1.35616",
  "crm-record-cards-service-types": "static-1.3579",
  "highcharts": "static-8.103",
  "trellis-story-utils": "static-1.4481",
  "storybook-react": "static-1.32",
  "hub-http-contrib": "static-1.3006",
  "tinymce-data": "static-1.40348",
  "ui-addon-sales-email": "static-1.5177",
  "codemirror": "static-5.94",
  "layout-dnd-components": "static-1.12373",
  "layout-dnd-utils": "static-1.11348",
  "react-codemirror": "static-1.10590",
  "ui-brand-identity-lib": "static-1.15110",
  "NamespacedHubStyle": "static-2.9033",
  "outpost": "static-1.4151",
  "flux-actions": "static-1.331",
  "integrations-error-boundary-lib": "static-1.13419",
  "integrations-tracking-lib": "static-1.5565",
  "native-integrations-shared-strings": "static-1.7749",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10337",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.444",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68329",
  "layout-data-lib": "static-1.9673",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.2979",
  "google-sheets-integration-lib": "static-1.130",
  "microsoft-drive-integration-lib": "static-1.247",
  "advanced-menus-core": "static-1.15071",
  "advanced-menus-lib": "static-1.12019",
  "ExportDialog": "static-6.10360",
  "ui-memberships-settings-lib": "static-1.33945",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15070",
  "simple-menus-lib": "static-1.16587"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2186",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.464",
  "data-fetching-client": "/data-fetching-client/static-1.9638",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.428",
  "growth-payments-core": "/growth-payments-core/static-1.25269",
  "head-dlb": "/head-dlb/static-1.4938",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5559",
  "hs-test-utils": "/hs-test-utils/static-1.7981",
  "hub-http": "/hub-http/static-1.6187",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9874",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18141",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyleTokens": "/HubStyleTokens/static-2.11427",
  "I18n": "/I18n/static-7.1615",
  "immutable": "/immutable/static-2.77",
  "jasmine-runner": "/jasmine-runner/static-1.6433",
  "payment-link-components": "/payment-link-components/static-1.23433",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.6973",
  "quartz-core": "/quartz-core/static-1.6192",
  "react": "/react/static-7.185",
  "react-colorpicker": "/react-colorpicker/static-2.10177",
  "react-dlb": "/react-dlb/static-1.78",
  "react-utils": "/react-utils/static-2.5315",
  "rich-text-lib": "/rich-text-lib/static-1.19768",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17935",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5565",
  "UIComponents": "/UIComponents/static-3.8374",
  "foundations-assets": "/foundations-assets/static-1.4823",
  "foundations-components": "/foundations-components/static-1.7857",
  "foundations-theming": "/foundations-theming/static-1.4383",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2099",
  "framer-motion": "/framer-motion/static-1.71",
  "metrics-js": "/metrics-js/static-1.9542",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "portals-platform-lib": "/portals-platform-lib/static-1.833",
  "quartz-config": "/quartz-config/static-1.751",
  "quartz-routing": "/quartz-routing/static-1.403",
  "quick-fetch": "/quick-fetch/static-1.3887",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16634",
  "rpc-client-utils": "/rpc-client-utils/static-1.4617",
  "sanitize-text": "/sanitize-text/static-1.8109",
  "styled-components": "/styled-components/static-2.88",
  "tanstack-table": "/tanstack-table/static-1.54",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4735",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9511",
  "usage-tracker": "/usage-tracker/static-1.7303",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5720",
  "usage-tracker-core": "/usage-tracker-core/static-1.7153",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "raven": "/raven/static-3.5829",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.70",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3374",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3250",
  "quartz-webpack": "/quartz-webpack/static-1.3197",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.51",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.81",
  "customer-data-objects": "/customer-data-objects/static-1.7629",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7895",
  "laboratory-lib": "/laboratory-lib/static-3.7125",
  "onboarding-scopes": "/onboarding-scopes/static-1.6428",
  "ui-addon-opt": "/ui-addon-opt/static-4.8337",
  "HeadJS": "/HeadJS/static-2.742",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3092",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.151",
  "hs-locale-management": "/hs-locale-management/static-1.55",
  "ts-schema": "/ts-schema/static-1.4049",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7696",
  "cssUtils": "/cssUtils/static-1.782",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9793",
  "HubStyle": "/HubStyle/static-2.11735",
  "knowledge-content-types": "/knowledge-content-types/static-1.8483",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "quartz-i18n": "/quartz-i18n/static-1.648",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9854",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11116",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9015",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10118",
  "video-components-external": "/video-components-external/static-1.11150",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.82",
  "jasmine": "/jasmine/static-4.4290",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6025",
  "customer-data-properties": "/customer-data-properties/static-1.51422",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18401",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5047",
  "onboarding-tours": "/onboarding-tours/static-1.16528",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8060",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3606",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9024",
  "user-context": "/user-context/static-1.5069",
  "dispatcher": "/dispatcher/static-1.135",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.828",
  "hubspotter-http": "/hubspotter-http/static-1.4623",
  "icons": "/icons/static-2.644",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.516",
  "module-federation": "/module-federation/static-1.22",
  "quartz-auth": "/quartz-auth/static-1.648",
  "quartz-head": "/quartz-head/static-1.638",
  "quartz-test": "/quartz-test/static-1.648",
  "quartz-tracking": "/quartz-tracking/static-1.352",
  "ui-fonts": "/ui-fonts/static-1.689",
  "usage-tracker-container": "/usage-tracker-container/static-1.7293",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9395",
  "data-token-picker": "/data-token-picker/static-1.16342",
  "FileManagerLib": "/FileManagerLib/static-1.39155",
  "property-translator": "/property-translator/static-1.5367",
  "atom": "/atom/static-1.5038",
  "merchandise-lib": "/merchandise-lib/static-1.262",
  "purchase-motions-components": "/purchase-motions-components/static-1.5817",
  "salesImages": "/salesImages/static-1.524",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5340",
  "react-select-plus": "/react-select-plus/static-1.104",
  "react-virtualized": "/react-virtualized/static-2.98",
  "ui-images": "/ui-images/static-2.1143",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4126",
  "floating-ui": "/floating-ui/static-1.55",
  "react-aria": "/react-aria/static-1.65",
  "react-create-root-preference": "/react-create-root-preference/static-1.13",
  "trellis-assets": "/trellis-assets/static-1.1746",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2866",
  "foundations-theming-base": "/foundations-theming-base/static-1.3368",
  "stylex": "/stylex/static-1.32",
  "interframe": "/interframe/static-3.4727",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5717",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "web-vitals": "/web-vitals/static-1.4",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.27",
  "chirp-fetch": "/chirp-fetch/static-1.1851",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4438",
  "react-flip-move": "/react-flip-move/static-1.69",
  "bender-build-tools": "/bender-build-tools/static-1.3147",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3811",
  "superstore": "/superstore/static-1.4732",
  "feedback-loader": "/feedback-loader/static-1.29229",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8844",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8664",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28445",
  "sassPrefix": "/sassPrefix/static-1.155",
  "react-dnd-compat": "/react-dnd-compat/static-1.4586",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2464",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8135",
  "reselect": "/reselect/static-2.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4614",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12135",
  "content-media-compositions": "/content-media-compositions/static-2.16142",
  "idb-keyval": "/idb-keyval/static-1.43",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4120",
  "magpie-lib": "/magpie-lib/static-1.5536",
  "magpie-types": "/magpie-types/static-1.4996",
  "media-bridge-lib": "/media-bridge-lib/static-1.18864",
  "video-data-lib": "/video-data-lib/static-1.34808",
  "commerce-products-lib": "/commerce-products-lib/static-1.9407",
  "crm-message-bus": "/crm-message-bus/static-1.42894",
  "growth-data-modal": "/growth-data-modal/static-1.5370",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4842",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4742",
  "calling-global-api": "/calling-global-api/static-1.64385",
  "calling-internal-common": "/calling-internal-common/static-1.31268",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65767",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58061",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3768",
  "crm-links": "/crm-links/static-1.6250",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12992",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9201",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8049",
  "external-options-client-types": "/external-options-client-types/static-1.4129",
  "file-manager-components": "/file-manager-components/static-1.23515",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6846",
  "google-libphonenumber": "/google-libphonenumber/static-1.37",
  "hs-resources": "/hs-resources/static-1.115",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3561",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4194",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.598",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3662",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48615",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3936",
  "property-value-citations": "/property-value-citations/static-1.2036",
  "pulse": "/pulse/static-1.529",
  "smart-property-lib": "/smart-property-lib/static-1.6736",
  "tiered-pricing": "/tiered-pricing/static-1.1126",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10954",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3033",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1817",
  "navigation-components": "/navigation-components/static-1.17912",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.594",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7499",
  "ui-universal-auth": "/ui-universal-auth/static-1.8930",
  "batch-promise": "/batch-promise/static-1.1510",
  "navigation-messaging": "/navigation-messaging/static-1.7239",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17519",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9872",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4989",
  "audio-components": "/audio-components/static-1.5861",
  "FileManagerCore": "/FileManagerCore/static-1.39014",
  "FileManagerImages": "/FileManagerImages/static-1.36666",
  "video-components": "/video-components/static-1.13153",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.882",
  "purchase-motions-api": "/purchase-motions-api/static-1.5820",
  "self-service-api": "/self-service-api/static-1.10212",
  "signup-constants": "/signup-constants/static-1.18780",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8007",
  "trials-service-types": "/trials-service-types/static-1.3870",
  "usage-tracker-public": "/usage-tracker-public/static-1.7114",
  "chatspot-core": "/chatspot-core/static-1.21121",
  "ContentUtils": "/ContentUtils/static-1.68254",
  "copilot-toolkit": "/copilot-toolkit/static-1.11037",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6549",
  "reactive-lib": "/reactive-lib/static-1.687",
  "simple-logging-lib": "/simple-logging-lib/static-1.3015",
  "commerce-permissions": "/commerce-permissions/static-1.732",
  "customer-data-tracking": "/customer-data-tracking/static-1.6852",
  "products-iframe-lib": "/products-iframe-lib/static-1.7832",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10256",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1901",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.301",
  "calling-error-reporting": "/calling-error-reporting/static-1.31274",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11004",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6509",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.839",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7215",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9144",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4113",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3980",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6751",
  "persist-promise": "/persist-promise/static-1.3667",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.32",
  "directed-graph": "/directed-graph/static-1.901",
  "event-emitter": "/event-emitter/static-1.914",
  "fast-json-patch": "/fast-json-patch/static-1.62",
  "data-agent-kit": "/data-agent-kit/static-1.135",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9957",
  "fsm": "/fsm/static-1.3697",
  "policy-lib": "/policy-lib/static-1.6739",
  "react-tinymce": "/react-tinymce/static-1.55137",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10020",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54263",
  "tinymce-plugins": "/tinymce-plugins/static-1.57377",
  "tinymce-themes": "/tinymce-themes/static-1.56233",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1845",
  "user-context-client": "/user-context-client/static-1.4576",
  "nest": "/nest/static-1.193",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.725",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4497",
  "video-embed": "/video-embed/static-1.35642",
  "content-icons-ui": "/content-icons-ui/static-1.2216",
  "social-insights-client-types": "/social-insights-client-types/static-1.21993",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4778",
  "integrations-lib": "/integrations-lib/static-1.16004",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.4231",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14713",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35616",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3579",
  "highcharts": "/highcharts/static-8.103",
  "trellis-story-utils": "/trellis-story-utils/static-1.4481",
  "storybook-react": "/storybook-react/static-1.32",
  "hub-http-contrib": "/hub-http-contrib/static-1.3006",
  "tinymce-data": "/tinymce-data/static-1.40348",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5177",
  "codemirror": "/codemirror/static-5.94",
  "layout-dnd-components": "/layout-dnd-components/static-1.12373",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11348",
  "react-codemirror": "/react-codemirror/static-1.10590",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15110",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9033",
  "outpost": "/outpost/static-1.4151",
  "flux-actions": "/flux-actions/static-1.331",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13419",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5565",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7749",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10337",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.444",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68329",
  "layout-data-lib": "/layout-data-lib/static-1.9673",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2979",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.130",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.247",
  "advanced-menus-core": "/advanced-menus-core/static-1.15071",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12019",
  "ExportDialog": "/ExportDialog/static-6.10360",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33945",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15070",
  "simple-menus-lib": "/simple-menus-lib/static-1.16587"
}
};
